import { render, staticRenderFns } from "./RxSubject.vue?vue&type=template&id=be64c9d8"
import script from "./RxSubject.vue?vue&type=script&lang=js"
export * from "./RxSubject.vue?vue&type=script&lang=js"
import style0 from "./RxSubject.vue?vue&type=style&index=0&id=be64c9d8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports